import { AppAreaConfig } from '@/funnels/@types'
import taiChiWalkingPrintable from './activity-female-tai-chi-walking-pr'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-chair-tai-chi-fwf',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-chair-tai-chi-f', 'age-chair-tai-chi-f'],
		route: {
			path: '/chair-tai-chi-f-fwf',
			name: 'female-chair-tai-chi-fwf-funnel',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi-chair-fwf',
		route: {
			path: '/chair-tai-chi-f-fwf/ob/:page*',
			name: 'activity-female-chair-tai-chi-fwf',
		},
		slug: 'activity-female-chair-tai-chi-fwf',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			always: {
				appArea: taiChiWalkingPrintable,
				page: 'focus-area',
			},
		},
	},
}

export default appAreaConfig
